<template>
  <div class="body-wrapper">
    <div class="left-column">
      <div class="box">
        <div class="title-wrapper main-title flex">
          <b class="title">Informacije</b>
          <i class="fas fa-pen" @click="openEditProperty()"></i>
        </div>
        <spinner :size="20" line-fg-color="#00796b" v-if="loadingBasicInfo" />
        <div class="info-box">
          <div class="left-column" v-if="!loadingBasicInfo">
            <div class="div-description single-info">
              <small class="label">Broj stana</small>
              <h4 class="value">{{ property.description }}</h4>
            </div>
            <div class="div-description single-info">
              <small class="label">Sprat</small>
              <h4 class="value">{{ property.floor ? property.floor : '/' }}</h4>
            </div>
            <div class="fullname single-info">
              <small class="label">Površina</small>
              <h4 class="value">
                {{ property.area_size }}
              </h4>
            </div>
            <div class="div-description single-info">
              <small class="label">Broj članova domaćinstva</small>
              <h4 class="value">{{ property.num_of_members }}</h4>
            </div>
            <div class="fullname single-info">
              <small class="label">Napomena</small>
              <h4 class="value">
                {{ property.note ? property.note : '/' }}
              </h4>
            </div>
            <div class="fullname single-info">
              <small class="label">Konakt osoba</small>
              <h4 class="value">
                {{ property.contact_full_name }}
              </h4>
              <div class="fullname single-info">
                <small class="label">Kontakt telefon</small>
                <h4 class="value">
                  {{ property.contact_phone ? property.contact_phone : '/' }}
                </h4>
              </div>
              <div class="fullname single-info">
                <small class="label">Email</small>
                <h4 class="value">
                  {{ property.contact_email ? property.contact_email : '/' }}
                </h4>
              </div>

              <div class="fullname single-info">
                <small class="label">Broj glasova</small>
                <h4 class="value">
                  {{ property.voting_points }}
                </h4>
              </div>
            </div>
          </div>
          <!-- <div class="right-column">
            <div class="single-info balance">
              <small class="label">Stanje (RSD)</small>
              <h2 class="value">1</h2>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="right-column">
      <div class="box transactions">
        <div class="title-wrapper">
          <b class="title">Korisnici aplikacije</b>
        </div>
        <div class="table">
          <spinner
            class="spinner"
            line-fg-color="#00796b"
            :size="100"
            :line-size="6"
            v-if="loading"
          ></spinner>
          <div v-show="!loading" class="transactions-table">
            <data-table
              :columns="table.tableColumns"
              :tableData="propertyDetails.members"
              :options="table.tableOptions"
            ></data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataTable from '@/components/community/Table';
import { mapState, mapActions, mapMutations } from 'vuex';
import { financesInstance } from '@/axios/axios.js';
import axios from '@/axios/axios.js';
import { utilService } from '@/util/UtilService.js';
import { addSeparatorMixin } from '@/mixins/mixins.js';
import modalConfirmAction from '@/components/modal/ModalConfirmAction.vue';
import checkbox from '@/components/common/Checkbox.vue';
import uploadButton from '@/components/modal/modal-content/ModalContentPollUploadButton.vue';

export default {
  name: 'CommunityFinancesMember',
  components: {
    DataTable
  },
  mixins: [addSeparatorMixin],
  data() {
    //TODO Add member actions
    return {
      propertyDetails: {
        members: []
      },
      loadingBasicInfo: true,
      table: {
        tableColumns: ['user.full_name', 'user.email', 'user.phone'],
        tableOptions: {
          filterable: true,
          headings: {
            'user.full_name': 'Ime',
            'user.email': 'Email',
            'user.phone': 'Telefon',
            action: 'Akcije'
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje korisnici aplikacije'
          },
          sortable: ['file_name']
        }
      }
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('table', ['tableColumns', 'tableData', 'tableOptions']),
    ...mapState('modal', ['property'])
  },
  async created() {
    this.setTableBadge('fa fa-users');
    try {
      const result = await axios.post(
        `/property/${this.$route.params.propertyId}`,
        {
          member_id: this.$store.getters.getActiveCommunity.member_id
        }
      );
      this.propertyDetails = result.data;
      this.setProperty(this.propertyDetails.property);
      this.loadingBasicInfo = false;
    } catch (error) {
      if (error.response.status == 404) {
        this.$router.push('/notFound');
      } else {
        console.log(error);
        this.showFailModal();
        this.back();
      }
    }
    // console.log('route', this.$route.params.contractorId);
  },
  methods: {
    ...mapMutations(['cardOpened']),
    ...mapMutations('modal', ['setProperty', 'showModal']),
    ...mapMutations('table', ['setTableData', 'setTableBadge']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    back() {
      this.$router.back();
    },
    openEditProperty() {
      this.showModal('ModalContectEditProperty');
    },
    toggleItems(contact) {
      contact.isExpanded = !contact.isExpanded;
      //   this.contractor.contacts = [...this.contractor.contacts];
    },
    isExpanded(contact) {
      if (contact.isExpanded) {
        console.log('aaa', contact.isExpanded);
        return contact.isExpanded;
      }
      console.log('aaa', false);
      return false;
    }
  }
};
</script>
<style lang="scss" scoped>
.header-contractor {
  margin-bottom: 40px;
  .badge--mod {
    position: absolute;
    right: 0;
    left: unset;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
  }
}
.transactions-table {
  tr {
    cursor: default !important;
  }
}
.invoice-date {
  background: none !important;
  font-size: 0.8rem;
  font-weight: 800;
}
.box {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0), 0 2px 15px rgba(0, 0, 0, 0.24);
  margin-bottom: 1rem;
  padding: 16px;
  position: relative;
}

.title-wrapper {
  margin-bottom: 12px;
  .title {
    font-size: 1.2rem;
    color: black;
    padding-bottom: 4px;
    border-bottom: 1px solid var(--primary-color);
  }

  .btn {
    color: var(--primary-color);
    background: #e6e6e6;
    padding: 2px 5px;
    font-size: 0.9rem;
    float: right;
    margin-right: 14px;
    &:hover {
      background: rgb(210, 210, 210);
    }
  }

  .icons-wrapper {
    display: inline-block;
    margin-left: auto;
    font-size: 1.4rem;
    i {
      padding: 7px 5px;
    }
    .box-icon {
      // position: absolute;
      // top: 0.8rem;
      // right: 0.8rem;
      color: var(--primary-color);
    }
    .invite-members-icon {
      background-color: #e6e6e6;
      padding: 7px 5px;
      border-radius: 5px;
      transition: background-color 0.2s;
    }

    .invite-members-icon:hover {
      background-color: #d2d2d2;
      cursor: pointer;
    }

    .icon-notice {
      color: #d2d2d2;
      transition: color 0.2s;
    }

    .icon-notice:hover {
      color: #dc3546;
      cursor: pointer;
    }

    .icon-default {
      color: #d2d2d2;
      transition: color 0.2s;
    }

    .icon-default:hover {
      color: var(--primary-color);
      cursor: pointer;
    }
  }
}

.body-wrapper {
  display: flex;
  height: 100%;
  .left-column {
    flex: 1;
    height: 100%;
    .info-box {
      width: 100%;
      // border: 1px solid var(--primary-color);
      border-radius: 4px;
      display: flex;
      align-items: flex-end;
      // padding: 8px 8px 8px 0;
      padding: 0;
      .left-column {
        flex: 5;
        display: flex;
        flex-direction: column;
      }
      .right-column {
        flex: 3;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
      }

      .single-info {
        // margin-left: 8px;
        // border: 1px solid black;
        display: flex;
        flex-direction: column;
        padding-top: 2px;
        margin-bottom: 2px;
        &.balance {
          &.positive {
            .value {
              color: var(--primary-color);
            }
          }
          &.negative {
            .value {
              color: rgba(220, 53, 70, 1);
            }
          }
          small {
            text-align: right;
          }
        }
      }

      h2,
      h4 {
        padding: 0;
        margin: 0;
        word-break: break-word;
      }
    }
    .invoices {
      width: 100%;
      height: calc(100% - 220px);
    }
  }
  .right-column {
    flex: 2;
    margin-left: 1rem;
  }
  .table {
    margin-bottom: 0;
    font-size: 0.9rem;
    position: relative;
    z-index: 0;
    height: calc(100% - 30px);

    .right-padding {
      .column:last-of-type {
        padding-right: 0.7rem;
      }
    }

    .rows {
      max-height: calc(100% - 30px);
      overflow-y: auto;

      .row {
        width: 100% !important;
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .parent {
          padding: 3px 0;
          width: 100%;
          display: flex;
        }

        .more-btn {
          cursor: pointer;
          i {
            transform: rotate(0);
            transition: transform 0.2s;
          }
        }

        .items {
          display: none;
          width: 90%;
          flex-direction: column;
          .row {
            display: flex;
            flex-direction: row;
            background: rgb(240, 240, 240);
            padding-left: 6px;
            border-radius: 4px;
            margin-bottom: 2px;
          }
          .row-desc {
            font-weight: bold;
          }
          .column {
            word-break: break-word;
          }
        }

        &.expanded-content {
          .items {
            display: flex;
          }
          .more-btn {
            i {
              transform: rotate(90deg);
            }
          }
        }

        .column {
          text-align: left;
          display: flex;
          align-items: center;
        }
      }
    }
    .labels {
      border-bottom: 1px solid gray;
      .column {
        font-weight: 600;
      }
    }
    .actions {
      display: flex;
      justify-content: flex-end;
      padding-right: 10px;
      .btn {
        background: rgb(230, 230, 230);
        margin: 0 4px;
        height: 24px;
        width: 24px;
        padding: 0 0 2px 2px;
        position: relative;
        &:hover {
          background: rgb(210, 210, 210);
        }
        i {
          font-size: 0.9rem;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: var(--primary-color);
        }
      }
    }
  }
}
.email-field {
  margin: 3px 0;
}
.email-subject {
  margin-bottom: 5px;
}

.main-title {
  display: flex;
  justify-content: space-between;
  i {
    color: var(--primary-color);
    cursor: pointer;
  }
}

.upload-area {
  margin-top: 5px;
  padding: 5px 0;

  .no-files {
    padding: 0 5px;
  }
  .uploaded {
    background-color: rgb(241, 241, 241);
    border-radius: 4px;
  }
  .file {
    border-bottom: solid 1px lightgray;
    font-size: 15px;
    width: 100%;
    display: inline-flex;
    align-items: center;
    padding: 0 5px;
    p {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      padding-right: 8px;
      margin-bottom: 2px;
    }

    .del--mod {
      margin-left: auto;

      cursor: pointer;
      color: red;
    }
  }
}
</style>
